module.exports = __webpack_public_path__ + "assets/sail.0e1a836e.svg";